module.exports = __webpack_public_path__ + "static/media/raj_agarwal.a43852b7.png";